'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactColor = require('react-color');

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColorPickerWrap = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ColorPickerWrap, _Component);

  function ColorPickerWrap(props) {
    (0, _classCallCheck3.default)(this, ColorPickerWrap);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ColorPickerWrap.__proto__ || (0, _getPrototypeOf2.default)(ColorPickerWrap)).call(this, props));

    _this.handleClick = function () {
      _this.setState({ displayColorPicker: !_this.state.displayColorPicker });
    };

    _this.handleClose = function () {
      _this.setState({ displayColorPicker: false });
    };

    _this.state = { displayColorPicker: false };
    return _this;
  }

  (0, _createClass3.default)(ColorPickerWrap, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var styles = this.styles;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className), style: styles.root },
        _react2.default.createElement(
          'div',
          { style: styles.swatch, onClick: this.handleClick },
          _react2.default.createElement('div', { style: styles.color })
        ),
        (this.state.displayColorPicker || null) && _react2.default.createElement(
          'div',
          { style: styles.popover },
          _react2.default.createElement('div', { style: styles.cover, onClick: this.handleClose }),
          _react2.default.createElement(_reactColor.SketchPicker, this.props)
        )
      );
    }
  }, {
    key: 'styles',
    get: function get() {
      return (0, _reactcss2.default)({
        default: {
          root: {
            position: 'relative'
          },
          color: {
            width: '36px',
            height: '14px',
            borderRadius: '2px',
            background: this.props.color
          },
          swatch: {
            padding: '5px',
            background: '#fff',
            borderRadius: '1px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
            cursor: 'pointer'
          },
          popover: {
            position: 'absolute',
            zIndex: '2'
          },
          cover: {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
            zIndex: '-1'
          }
        }
      });
    }
  }]);
  return ColorPickerWrap;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  color: _react.PropTypes.string
}, _temp);
exports.default = ColorPickerWrap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ColorPickerWrap/ColorPickerWrap.jsx
// module id = 1566
// module chunks = 0